import { apiRequest } from '../../lib/api-client.js';

export interface SuperUserRow {
  id: number;
  email: string;
  name: string;
  status: 'active' | 'inactive';
  totp_confirmed: boolean;
  last_login_at: string | null;
  created_at: string;
}

export interface CreateSuperUserInput {
  email: string;
  password: string;
  name: string;
}

export type SyncJobStatus = 'success' | 'pending' | 'in_progress' | 'failed' | 'never_synced';

export interface SyncStatusDetail {
  server_id: number;
  server_name: string;
  status: SyncJobStatus;
  attempts: number;
  last_error: string | null;
  last_attempt_at: string | null;
}

export interface SyncStatus {
  total: number;
  success: number;
  pending: number;
  failed: number;
  details: SyncStatusDetail[];
}

export const superUsersApi = {
  list: () => apiRequest<SuperUserRow[]>('/api/super-users'),
  create: (body: CreateSuperUserInput) =>
    apiRequest<SuperUserRow>('/api/super-users', { method: 'POST', body }),
  delete: (id: number) => apiRequest<void>(`/api/super-users/${id}`, { method: 'DELETE' }),
  patch: (id: number, body: { status?: 'active' | 'inactive'; name?: string }) =>
    apiRequest<SuperUserRow>(`/api/super-users/${id}`, { method: 'PATCH', body }),
  resetPassword: (id: number, password: string) =>
    apiRequest<void>(`/api/super-users/${id}/reset-password`, {
      method: 'POST',
      body: { password },
    }),
  syncStatus: (id: number) =>
    apiRequest<SyncStatus>(`/api/super-users/${id}/sync-status`),
  resync: (id: number) =>
    apiRequest<{ enqueued: number; processed: number; succeeded: number; failed: number }>(
      `/api/super-users/${id}/resync`,
      { method: 'POST' },
    ),
};
